import './WidgetTemplateCard.css';

import React, { useEffect, useState } from 'react';
import { Widgets } from '@mui/icons-material';
import FieldText from '../../b2b-common/FieldText';
import { truncateTextByCharacters } from '../../b2b-common/helpers';
import { AreaIndicatorWidgetModalContext } from '../forms/AreaIndicatorWidgetModal';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import { Box } from '@mui/material';

const WidgetTemplateCard = ({ widgetTemplate, selectedTemplate = null, onSelect }) => {

    const [currentWidgetTemplate, setCurrentWidgetTemplate] = useState(widgetTemplate);
    const [ selectedWidgetTemplate, setSelectedWidgetTemplate ] = useState(selectedTemplate);
    const { t } = useB2BTranslation('b2b-reporting');

    useEffect(() => {
        if (selectedTemplate !== null)
            setSelectedWidgetTemplate(selectedTemplate);
    }, [selectedTemplate]);

    useEffect(() => {
        if (widgetTemplate !== currentWidgetTemplate)
            setCurrentWidgetTemplate(widgetTemplate);
    }, [widgetTemplate]);

    const handleClickOnCard = () => {
        onSelect && onSelect(currentWidgetTemplate);
    }

    return (
        <Box className={`widget-config-card-container ${(selectedWidgetTemplate && (selectedWidgetTemplate.acronym == currentWidgetTemplate.acronym)) ? 'selected' : ''}`}
            onClick={handleClickOnCard} display={'flex'} flexDirection='row' alignItems='center' justifyContent='space-between' padding={1} margin={1} borderRadius={2} boxShadow={2} bgcolor={'white'}
            p={2}
        >
            <Box className='widget-config-card-image' width={'5%'}>
                <Widgets />
            </Box>
            <div className='widget-config-card-name'>
                <FieldText 
                    label={t('Widget Name')} 
                    labelAlign='left' 
                    text={truncateTextByCharacters(currentWidgetTemplate.name, 40)} 
                    textAlign='left' 
                    className={'widget-config-card-field'} 
                />
            </div>
            <div className='widget-config-card-description'>
                <FieldText 
                    label={t('Description')} 
                    labelAlign='left' 
                    text={truncateTextByCharacters(currentWidgetTemplate.description, 50)} 
                    textAlign='left' 
                    className={'widget-config-card-field'} 
                />
            </div>
        </Box>
    );
};

export default WidgetTemplateCard;